// extracted by mini-css-extract-plugin
module.exports = {"out_wrap":"project-out_out_wrap_3JrCt","img":"project-out_img_3Nrfj","tip":"project-out_tip_38RH5","tipTime":"project-out_tipTime_zAa3M","link":"project-out_link_1iZ6D"};